import React, {useEffect, useState } from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Single from '../../../componentes/Single'
import { Input, Label } from 'semantic-ui-react'
import InventarioTools from '../Componentes/editarInventario'

const Movimientos = () => {
    const [origen, setOrigen] = useState('');
    const [destino, setDestino] = useState('');
    const [producto, setProducto] = useState('');
    const [cantidad, setCantidad] = useState(0);
    const [unidades, setUnidades] = useState('');
    const [disponible, setDisponible] = useState(0);
    const [message, setMessage] = useState('');
    const [button, setButton] = useState(true);

    useEffect(()=>{
        if(origen === destino){
            setMessage("Origen y Destino tienen que ser distintos.")
            setButton(true)
        } else if(!producto){
            setMessage("Seleccione el producto")
            setButton(true)
        } else if(cantidad <= 0){
            setMessage("Cantidad tiene que ser mayor a 0")
            setButton(true)
        } else if(cantidad > disponible){
            setMessage("No hay suficiente producto en el inventario")
            setButton(true)
        }else if(!destino){
            setMessage("Seleccione el Destino")
            setButton(true)
        }else{
            setMessage('')
            setButton(false)
        }
        if(origen && producto){
            actualizarDisponible()
        }
    }, [origen, destino, cantidad, producto])
    const handleOrigenChange = (event, { value }) => {
        setOrigen(value)
    };
    const handleDestinoChange = (event, { value }) => {
        setDestino(value)
    };
    const handleCantidadChange = (event, { value }) => {
        setCantidad(value)
    };
    const handleProductoChange =  (event, { value }) => {
        setProducto(value)
    }
    const actualizarDisponible = async () => {
        const doc = (await firebase.firestore()
        .collection('Inventario')
        .where('nombre', '==', producto)
        .where('ubicacion', '==', origen)
        .get()).docs[0]
        if (doc === undefined){
            setDisponible(0)
        }else {
            setDisponible(+(doc.data().enInventario).toFixed(2))
            setUnidades(doc.data().unidades)
        }
    };
    const handleSubmit = () => {
        InventarioTools.mover(origen,destino,producto,parseFloat(cantidad),unidades).then(
            setOrigen(''),
            setDestino(''),
            setProducto(''),
            setDisponible(0)
        )
    }
    return (
        <div>
            <h3>Mover productos entre almacenes</h3>
            <div className="filtros">
                <div>Origen: <Single tabla='Almacen' columna='nombre' value={origen} onChange={handleOrigenChange} /></div>
                <div>Producto: <Single tabla='Presentacion' columna='producto' value={producto} onChange={handleProductoChange} /></div>
                <div>Disponible: {disponible} {unidades}</div>
                <div>Cantidad: <Input type='number' value={cantidad} onChange={handleCantidadChange} /></div>
                <div>Destino: <Single tabla='Almacen' columna='nombre' value={destino} onChange={handleDestinoChange} /></div>
                <button onClick={handleSubmit} disabled={button} >Mover</button>
            </div>
            {message !== '' ? <Label color="red">{message}</Label> : null}
        </div>
      );
}
export default Movimientos;